export const defaultBundleColorLabel = "Bundle Color";
